export default "__VITE_ASSET__0bbfeced__"